import { BankNames } from '@/constants';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';
import type { OfferResponseFromApi } from '@/types/offers';

import type { IBaseBankOffer } from '../../../types/base-offer.types';
import type { TEurasV1BankOffer } from '../../../types/euras-v1.types';

export const mapEuBankV1OfferFromApi = (
  baseBankOffer: IBaseBankOffer,
  response: OfferResponseFromApi
): TEurasV1BankOffer => {
  const offer = { ...baseBankOffer };

  const parsedResponseApprovedBody: IEurasV1ResponseApprovedBody | null =
    response?.response_approved_body &&
    checkIsValidJSON(response.response_approved_body)
      ? JSON.parse(response.response_approved_body)
      : null;

  const isParsedDataValid =
    parsedResponseApprovedBody?.alternative ||
    parsedResponseApprovedBody?.calculation;
  const monthlyPayment = isParsedDataValid
    ? parsedResponseApprovedBody?.status === 'ALTERNATIVE'
      ? parsedResponseApprovedBody?.alternative?.monthlyPayment1
      : parsedResponseApprovedBody?.calculation?.monthlyPayment1 || ''
    : baseBankOffer.monthlyPayment;
  const rate = isParsedDataValid
    ? Number(parsedResponseApprovedBody?.calculation?.yearlyRate).toFixed(2) ||
      '0'
    : baseBankOffer.rate;

  const productInfo = response?.request?.RequestsProducts
    ? response?.request?.RequestsProducts.find(
        (product) => product.product.bank_uuid === response.bank_uuid
      )
    : '';

  return {
    ...offer,
    bankName: BankNames.euBank,
    monthlyPayment,
    rate,
    productInfo
  };
};

interface IEurasV1ResponseApprovedBody {
  status: string;
  alternative: {
    monthlyPayment1: string;
  };
  calculation: {
    monthlyPayment1: string;
    yearlyRate: string;
  };
}
